import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CRMPage from "@/pages/CRMPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import PipelinePage from "@/pages/PipelinePage";
import MarketingPage from "@/pages/MarketingPage";
import HealthCalendarPage from "@/pages/HealthCalendarPage";
import NewsletterPage from "@/pages/NewsletterPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import TasksPage from "@/pages/TasksPage";
import AutomationsPage from "@/pages/AutomationsPage";
import ActionCenterPage from "@/pages/ActionCenterPage";
import AlertsPage from "@/pages/AlertsPage";
import ImportExcelPage from "@/pages/ImportExcelPage";
import ContactsPage from "@/pages/ContactsPage";
import ContactDetailPage from "@/pages/ContactDetailPage";

function Protected({ children }) {
    const { user, checking } = useAuth();
    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="pv-eyebrow text-textsubtle">Caricamento…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export default function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            path="/"
                            element={
                                <Protected>
                                    <AppLayout />
                                </Protected>
                            }
                        >
                            <Route index element={<DashboardPage />} />
                            <Route path="crm" element={<CRMPage />} />
                            <Route path="crm/:id" element={<ClientDetailPage />} />
                            <Route path="pipeline" element={<PipelinePage />} />
                            <Route path="marketing" element={<MarketingPage />} />
                            <Route path="health-calendar" element={<HealthCalendarPage />} />
                            <Route path="newsletter" element={<NewsletterPage />} />
                            <Route path="analytics" element={<AnalyticsPage />} />
                            <Route path="tasks" element={<TasksPage />} />
                            <Route path="automations" element={<AutomationsPage />} />
                            <Route path="actions" element={<ActionCenterPage />} />
                            <Route path="alerts" element={<AlertsPage />} />
                            <Route path="contacts" element={<ContactsPage />} />
                            <Route path="contacts/:id" element={<ContactDetailPage />} />
                            <Route path="admin/import" element={<ImportExcelPage />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </ThemeProvider>
    );
}
